<template>
    <div>
        <FilterTable 
          :resource_name="resource_name"
          :resource_identifier="resource_identifier"
          :title="title"
          :field_definitions="field_definitions"
          :action_buttons="action_buttons"
          :row_actions="row_actions"
          :translate_to_display_data="translate_to_display_data"
          :route_root="route_root"
          :handle_row_action="handle_row_action"
          :handle_action_button_click="handle_action_button_click"
          :update_flag="filter_table_update_flag"
        />
        <LoadingBlock
          :active="loading">
        </LoadingBlock>
    </div>
</template>

<script>
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import api from '@/api/index'
import FilterTable from '@/components/backstage/FilterTable/FilterTable.vue'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'

export default {
    mixins: [breadcrumbMixin],
    components: {
      FilterTable,
      LoadingBlock,
    },
    created () {
      this.permission_check({
        resource_info: { name: this.page_name.PAGE_RECORDGROUP_MANAGEMENT },
        access: { name: this.permission.VIEW },
        reject: { action: this.permission.REJECT_REDIRECT, path: '/dashboard' }
      })
    },
    data() {
      return {
        // 0.類型(公文/圖說(技術文件)/出版品/影像/文物器具/口述史料/文化自然景觀/建築物、土木設施與遺址類)
        // 1.全宗名(ex. 大元山)
        // 2.全宗號(ex. DY)
        // 3.單件題名(title)(ex. 世紀之森)
        // 4.對外授權(是/否) rights_outside
        // 5.是否有數位物件(是/否)
        // 6.狀態(毀損/良好)
        // 7.建立時間(YYYY-MM-DD)
        resource_name: 'organization',
        title: '全宗管理',
        route_root: 'file-type-management',
        resource_identifier: {
          name: 'hierarchy_name',
          value: 'recordgroup',
          form: 'formdata'
        },
        field_definitions: [
          {
            display: {
              name: '全宗號',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'recordgroup_number',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '全宗名',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'recordgroup_name',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '關鍵字',
              type: 'multi-string',
              sortable: false,
            },
            source: {
              type: 'db',
              key: 'recordgroup_keywords',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '摘要',
              type: 'string',
              sortable: false,
            },
            source: {
              type: 'db',
              key: 'recordgroup_abstract',
              data_type: 'string',
            } 
          },
        ],
        action_buttons: {
          add: {
            label: '新增全宗',
            action: 'add'
          },
        },
        row_actions: {
          get: {
            label: '檢視',
            action: 'get'
          },
          edit: {
            label: '編輯',
            action: 'edit'
          },
          delete: {
            label: '刪除',
            action: 'delete'
          },
        },

        dialog_visible: false,
        dialog_btn_enabled: false,
        dialog_selection: null,
        filter_table_update_flag: 0,

        loading: false,
      }
    },
    methods: {
      translate_to_display_data(data) {
        console.log('translate_to_display_data')

        let types = {}
        this.field_definitions.forEach(
          function (field) {
            types[field['source']['key']] = field['source']['data_type']
          })

        let translated_data = data
        
        for (let key in data) {
          if (types[key] === 'datetime' && data[key]) {
            translated_data[key] = data[key].date.slice(0,-7)
          }
        }
        
        return translated_data
      },
      handle_row_action (action, index, row) {
        console.log('RecordGroupManagement: action:' + action + ', index: ' + index + ', row: ', row)

          switch(action){
            case 'get': 
                this.backstage_router_push({ path: `/${this.route_root}/recordgroup/view/${row.id}` })
                break
            case 'edit': 
                this.backstage_router_push({ path: `/${this.route_root}/recordgroup/edit/${row.id}` })
                break
            case 'delete': 
                this.handle_action_delete(row.id)
                break
            default:
                break
          }
      },
      handle_action_button_click (action) {
        console.log('RecordGroupManagement: action button clicked: ', action)

        switch(action){
          case 'add': 
              this.backstage_router_push({ path: `/${this.route_root}/recordgroup/add` })
            break
          case 'export': 
              break
          default:
              break
        }
      },
      trigger_table_update () {
        this.filter_table_update_flag += 1
      },
      async handle_action_delete (id) {
        console.log('FolderManagement: delete button clicked')

        this.loading = true

        let res = await api.get_article_number_under_organization('recordgroup', id)
        if (res.success !== true) {
          this.notify_message(this.ERROR.LEVEL.ERROR, '刪除失敗', res.message)
          this.loading = false
          return 
        }

        res = await this.$confirm('刪除後無法回復，是否刪除?', '提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          return true
        }).catch(() => {
          this.notify_message(this.ERROR.LEVEL.INFO, '已取消刪除')      
          return false  
        });

        if (res === false) {
          this.loading = false
          return
        }
                
        res = await api.organization_delete('recordgroup', id)
        if (res.success === true) {
          this.notify_message(this.ERROR.LEVEL.SUCCESS, '刪除成功')
          this.trigger_table_update()
        }
        else {
          console.log('[ERR] failed to delete folder, error=', res.error)
          this.notify_message(this.ERROR.LEVEL.ERROR, '刪除失敗', res.message)
        }
        this.loading = false
      },
    }
  };
</script>

<style>
</style>
